import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const PageTitle = modules[vendor] ? modules[vendor] : modules["default"];

export default PageTitle;
